import { configureStore, ThunkAction, Action, combineReducers, AnyAction, Reducer } from "@reduxjs/toolkit";

import { ssoApi } from "@sso/apis";

import { appReducers } from "./slices";
import { logOutUser } from "./slices/auth";

const rootReducers = combineReducers(appReducers);
const rootReducersEnhancer: Reducer<RootState, AnyAction> = (state, action) => {
  if (action.type === logOutUser.type) {
    state = undefined;
  }
  return rootReducers(state, action);
};

export const store = configureStore({
  reducer: rootReducersEnhancer,
  middleware: getDefaultMiddleware => getDefaultMiddleware().prepend([ssoApi.middleware]),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof rootReducers>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;